var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print-receipt",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9008 9.89844H17.8008V12.4984H23.9008V9.89844Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 14.5H12V17.1H23.8V14.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 19H12V21.6H23.8V19Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 3.8L21 1.5L17.9 3.8L14.9 1.5L11.8 3.8L7.4 0.5V11H0.5V23.8C0.6 25.1 1.1 26.2 2.1 27.1C3 27.9 4.1 28.3 5.3 28.3V28.5H23.8C26.4 28.5 28.6 26.4 28.6 23.8V0.5L24.2 3.8ZM3.1 23.8V13.6H7.4V23.7C7.3 24.8 6.5 25.6 5.4 25.7C4.8 25.7 4.3 25.5 3.9 25.2C3.4 24.8 3.2 24.3 3.1 23.8ZM25.9 23.8C25.9 25 24.9 25.9 23.8 25.9H9.5C9.8 25.3 10 24.5 10 23.8V11V5.7L11.8 7L14.9 4.7L18 7L21.1 4.7L24.2 7L25.9 5.7V23.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintReceipt);
export default __webpack_public_path__ + "static/media/print-receipt.3ff3c08609073b274099677488c3c996.svg";
export { ForwardRef as ReactComponent };